import axios from 'axios';
import APP_ID from '../constants';

const authAPI = axios.create({ baseURL: 'https://www.indaiatuba.sp.gov.br/AcessoWS/api/acesso'});

let token;

const getAuth = () => token || sessionStorage.getItem('token');

const setAuth = (authorization) => {
	token = authorization;
	sessionStorage.setItem('token', authorization);
};

const clearAuth = () => {
	token = null;
	sessionStorage.removeItem('token');
};

authAPI.interceptors.request.use(async (requestConfig) => {
	const token = (await getAuth()) || '';
	if (token) {
			requestConfig.headers.authorization = token;
	}
	return requestConfig;
});

const login = data => authAPI.post(`/login`, data);
const refresh = refreshToken => authAPI.get(`/refresh/${refreshToken}`);

const permissoes = () => authAPI.get(`/permissoes/${APP_ID}/?list`, {});


export default { authAPI, login, refresh, getAuth, setAuth, clearAuth, permissoes };